class EventUtil {
  static dispatch(eventType: string, params?: unknown) {
    if (!!document && !!document.body) {
      const event = new CustomEvent(eventType, { detail: params });
      document.body.dispatchEvent(event);
    }
  }

  static listen(eventType: string, callBack: EventListener, bubbles?: boolean) {
    try {
      if (!!document && !!document.body) {
        document.body.addEventListener(eventType, callBack, bubbles);
      }
    } catch {}
  }

  static remove(eventType: string, callBack: EventListener) {
    try {
      if (!!document && !!document.body) {
        document.body.removeEventListener(eventType, callBack);
      }
    } catch {}
  }
}

export { EventUtil };
